import ThesisPage from './ThesisPage';
export default ThesisPage;
